import ProfilePage from './Portfolio/ProfilePage'
import NewPortfolio from './Portfolio/NewPortfolio'
import SideBarEmail from './Portfolio/SideBarEmail'
import MainPortfolio from './NewPortfolio/MainPortfolio';

function App() {
  return (
    <div className="App">
      <MainPortfolio/>
      {/* <NewPortfolio/> */}
      {/* <SideBarEmail/> */}
    </div>
  );
}

export default App;
